import { useUseVenueEnabledFeaturePreviewsVenueQuery } from '../../graphql'

export enum VenueFeaturePreviews {
  HIDE_EVERSPORTS_BRANDING = 'user-hide-eversports-branding',
}

interface Props {
  venueId?: string
}

const useVenueEnabledFeaturePreviews = ({ venueId }: Props) => {
  const { data, loading } = useUseVenueEnabledFeaturePreviewsVenueQuery({
    skip: !venueId,
    variables: { venueId: venueId! },
  })
  return {
    enabledFeatures: data?.venue.enabledFeatures.map((feature) => feature.name) || [],
    loading,
  }
}

export default useVenueEnabledFeaturePreviews
